//@flow
import * as Immutable from 'immutable';

import {
    CustomQuantityUnit,
    UnitSettings
} from 'common/models/flow/UnitSettings';
import type {
    CustomQuantityUnitModelType,
    UnitSettingsModelType
} from 'common/models/flow/UnitSettings';

class InternalCustomQuantityUnit extends CustomQuantityUnit {
    static fromJS(
        json: CustomQuantityUnitModelType
    ): InternalCustomQuantityUnit {
        const state: Object = Object.assign({}, json);
        return new this(Immutable.Map(state));
    }
}

class InternalUnitSettings extends UnitSettings {
    static fromJS(json: UnitSettingsModelType): InternalUnitSettings {
        const state: Object = Object.assign({}, json);
        state.customQuantityUnits = Immutable.List(
            state.customQuantityUnits
        ).map(item => InternalCustomQuantityUnit.fromJS(item));
        return new this(Immutable.Map(state));
    }

    get customQuantityUnits(): Immutable.List<CustomQuantityUnit> {
        return this._state.get('customQuantityUnits');
    }
}

export {
    InternalCustomQuantityUnit as CustomQuantityUnit,
    InternalUnitSettings as UnitSettings
};
